import { Controller } from '@hotwired/stimulus';

import nestedy from '@/modules/nestedy';
import phoner from '@/modules/phoner';
import Zipcoder from '@/modules/zipcoder';

export default class extends Controller {
  connect() {
    this.bindVideos();

    phoner();

    new Zipcoder({ scope: 'personal' }).create();
  }

  bindVideos() {
    const videos = this.element.querySelector('[data-videos]');

    if (!videos) return;

    nestedy(videos, {
      change: (count) => document.querySelector('[data-videos-none]').classList.toggle('hidden', count > 0),
      template: '#video-template',
    }).init();
  }
}
